import { useRemoveManualScheduleMutation } from "../../../../../../redux/api/schedule/scheduleAPI";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../../../../shared/oversight-core/utils/toast";

interface IProps extends ModelContainerProps {
  show: boolean;
  spaceClusterId: string;
  subRootSpaceId: string;
  deleteScheduleData: {
    scheduleId: string;
    scheduleTitle: string;
  };
  onSuccess?: () => void;
}

const BillCalculatorDeleteModal = (props: IProps) => {
  const { show, ...rest } = props;
  // const navigate = useNavigate();

  const [
    removeManualScheduleMutation,
    { isLoading: isLoadingManualRemoveSpace },
  ] = useRemoveManualScheduleMutation();

  const handleOnConfirm = () => {
    removeManualScheduleMutation({
      spaceClusterId: props.spaceClusterId,
      subRootSpaceId: props.subRootSpaceId,
      scheduleId: props.deleteScheduleData.scheduleId,
    })
      .unwrap()
      .then(() => {
        showSuccessMessage("Schedule Deleted Successfully");
        props.onClose && props.onClose();
        props.onSuccess && props.onSuccess();
        // navigate(AppRoute.BILL_CALCULATOR);
      })
      .catch(() => {
        showErrorMessage("Failed to delete schedule");
        props.onClose && props.onClose();
      });
  };

  return (
    <ModalContainer
      {...rest}
      title={"Delete Schedule"}
      show={show}
      size="modal-md"
      confirmButtonText="Delete"
      confirmButtonVariant="red"
      cancelButtonText="Cancel"
      onConfirm={handleOnConfirm}
      isLoading={isLoadingManualRemoveSpace}
    >
      <>
        <p className="text-color-2 font-weight-400 font-size-14">
          <span className="font-weight-500">
            {props.deleteScheduleData.scheduleTitle} will be removed
            permanently,
          </span>{" "}
          Are you sure you want to delete this schedule? This action cannot be
          undone and all associated data will be permanently deleted
        </p>
        <p className="text-color-2 font-weight-400 font-size-14">
          If you&rsquo;ve added recurring events for this event, those will also
          be removed.
        </p>
        <p className="text-color-2 font-weight-400 font-size-14">
          if you just need to Remove the specific time slot, please use the edit
        </p>
      </>
    </ModalContainer>
  );
};

export default BillCalculatorDeleteModal;
